
(ns app.strive-forms.question-fields.date-field
  (:require-macros [reagent-mui.util :refer [react-component]])
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?]]
            [app.strive-forms.events :as events ]
            [app.strive-forms.helper-functions :refer [get-button-label]]
            [app.strive-forms.styles :refer [action-button-style]]
            [moment]
            [re-com.core :as re-com :refer [at v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.cljs-time-adapter :refer [cljs-time-adapter]]
            [reagent-mui.material.stack :refer [stack]]
            [reagent-mui.material.text-field :refer [text-field]]
            [reagent-mui.x.localization-provider :refer [localization-provider]]
            [reagent-mui.x.mobile-date-picker :refer [mobile-date-picker]]
            [reagent.core :as r])

)

(defn date-validity [date-range? start-date end-date date-to-save]
  (if date-range?
    (or (= (.format (moment @start-date) "YYYY-MM-DD") "Invalid date") (= (.format (moment @end-date) "YYYY-MM-DD") "Invalid date"))
    (= @date-to-save "Invalid date")))

(defn format-date [date-range? start-date end-date]
  (if date-range? 
    (str (.format (moment @start-date) "YYYY-MM-DD") " - " (.format (moment @end-date) "YYYY-MM-DD")) 
    (.format (moment @start-date) "YYYY-MM-DD")))

(defmethod show-action-btn? "date" [props]
  false)

(defn date-field [{:keys [field field-id index selected-language theme-data form-messages current-page input-data on-submit pre-filled regenerate-display-fields hidden-fields display-fields]}]
  (let [date-range? (:range (:additional_settings field))
        hour (* 60 60 1000)
        day (* 24 hour)
        week (* 7 day)
        start-date (r/atom (js/Date.))
        end-date (r/atom (+ (.now js/Date) (* week))) ;;make in a week
        submitted? (r/atom false)]
    ;;dont format when date is null
    (fn [{:keys [field field-id index selected-language theme-data form-messages current-page input-data hidden-fields display-fields]}]
      (let [date-to-save (r/atom @start-date)
            date-invalid? (r/atom (date-validity date-range? start-date end-date date-to-save))]
      [v-box
       :justify :center
       :align :center
       :gap "10px"
       :children [[v-box
                   :gap "38px"
                   
                   :children [[:div
                               {:style {:width (if (< (.-innerWidth js/window) 800)
                                                 "100%"
                                                 "736px")
                                        :display "flex"
                                        :justify-content "center"
                                        :gap "8px"}}
                               [localization-provider {:date-adapter   cljs-time-adapter
                                                       }
                                [stack
                                 [mobile-date-picker {:label "Start date"
                                                       :inputFormat "yyyy-MM-dd"
                                                       :value @start-date
                                                       :render-input (react-component [props]
                                                                                      [text-field props])
                                                       :on-change    (fn [value] 
                                                                       (reset! start-date (js/Date. value))
                                                                       (when (and (not= @end-date "") (> @start-date @end-date) ) (reset! end-date (js/Date. value))))}]]]
                               (when date-range?
                                 [localization-provider {:date-adapter   cljs-time-adapter
                                                         }
                                  [stack
                                   [mobile-date-picker {:label "End date"
                                                         :inputFormat "yyyy-MM-dd"
                                                         :value @end-date
                                                         :onChange (fn [value]
                                                                     (reset! end-date (js/Date. value))
                                                                     (when (> @start-date @end-date) (reset! start-date (js/Date. value))))
                                                         :renderInput (react-component [props]
                                                                                       [text-field props])}]]])]]]
                  [v-box
                   :src (at)
                   :gap "48px"
                   :children [[v-box
                               :src (at)
                               :width  (if (< (.-innerWidth js/window) 800)
                                         "100%"
                                         "586px")
                               :children [[:div {
                                                 ;:class (warning-notification)
                                                 } ""]]]
                              [re-com/button
                               :label (get-button-label {:index index :input-data input-data :form-messages form-messages})
                               :class (action-button-style {:theme-data theme-data})
                               :disabled? @date-invalid?
                               :on-click #(do
                                            (reset! submitted? true)
                                            ((re-frame/dispatch [::events/update-input-local {:input-data input-data :key (keyword field-id) :value @date-to-save}])
                                             (reset! current-page (+ 1 index))
                                             (regenerate-display-fields
                                              (update input-data (keyword field-id) (fn [value]
                                                                                      (assoc value :value @date-to-save)))) 
                                             (when (= (+ 1 index) (- (count input-data) 1))
                                               (on-submit))))]]]]]))))
